import { NgSignaturePadOptions, SignaturePadComponent as NgSignaturePadComponent } from '@almothafar/angular-signature-pad';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { EmployeesService } from 'src/app/services/employees.service';

@Component({
    selector: 'app-signature-pad',
    templateUrl: './signature-pad.component.html',
    styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent implements OnInit {
    @Input() height: number = window.innerHeight / 4;
    @Input() width: number = window.innerWidth - 50;
    @Output() firmaGuardada = new EventEmitter<string>();

    @ViewChild('signature')
    public signaturePad: NgSignaturePadComponent;

    firma: string = null;
    firmaTemporal: string = null;
    signaturePadOptions: NgSignaturePadOptions;

    constructor(
        public empleadosService: EmployeesService,
        private toastController: ToastController
    ) { }

    ngOnInit() {
        // Obtención de la firma del empleado
        this.empleadosService.getSignature()
            .subscribe((firma: string) => {
                console.log('firma', firma);
                this.firma = firma;
                if (firma) {
                    this.firmaGuardada.emit(firma);
                }
            });

        this.signaturePadOptions = {
            minWidth: 5,
            canvasWidth: this.width,
            canvasHeight: this.height,
            dotSize: 2
        };
    }

    drawComplete(event: MouseEvent | Touch) {
        console.log('Completed drawing', event);
        this.firmaTemporal = this.signaturePad.toDataURL();
    }

    drawStart(event: MouseEvent | Touch) {
        console.log('Start drawing', event);
    }

    guardarFirma(): void {
        if (this.firmaTemporal) {
            this.empleadosService.saveSignature(this.firmaTemporal)
                .subscribe((firma: boolean) => {
                    if (firma) {
                        this.firma = this.firmaTemporal;
                        this.firmaGuardada.emit(this.firma);
                        this.firmaTemporal = null;
                        this.mostrarMensajeFirmaGuardada();
                    }
                });
        }
    }

    async mostrarMensajeFirmaGuardada() {
        const toast = await this.toastController.create({
            message: 'Firma guardada correctamente',
            duration: 3000,
            color: 'success'
        });
        toast.present();
    }

    limpiarFirma(): void {
        this.signaturePad.clear();
        this.firmaTemporal = null;
    }
} 